// extracted by mini-css-extract-plugin
export default {"giftMyZoobck":"GiftMyZoo_giftMyZoobck__44A0B","giftZooDis":"GiftMyZoo_giftZooDis__N2nuR"};